import { render, staticRenderFns } from "./transferenciaUnidades.vue?vue&type=template&id=13a4c28b&scoped=true"
import script from "./transferenciaUnidades.vue?vue&type=script&lang=js"
export * from "./transferenciaUnidades.vue?vue&type=script&lang=js"
import style0 from "./transferenciaUnidades.vue?vue&type=style&index=0&id=13a4c28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a4c28b",
  null
  
)

export default component.exports